import React, { Fragment } from 'react';
import { Route, Navigate, Router, Routes, BrowserRouter, useLocation, useNavigate, useParams, Outlet } from 'react-router-dom';
import {
  LOGIN_ROUTE,
  HOME_ROUTE,
  COMPANY_PURCHASES_ROUTE,
  PURCHASE_STORIES_ROUTE,
  PURCHASE_ADD_STORY_ROUTE,
  PURCHASE_IMPORT_STORIES_ROUTE,
  STORY_ROUTE,
  STORY_LISTING_ROUTE,
  INVITE_SCREEN_ROUTE,
  ADMIN_USER_SCREEN_ROUTE,
  EDIT_STORY_SCREEN_ROUTE,
  ADD_COMPANY_ROUTE,
  COMPANY_ROUTE,
  USER_LISTING_ROUTE,
  USER_ROUTE,
  ALL_STORY_ROUTE,
  INVITE_USER,
  EDIT_COMPANY,
  REPORT,
  INSIGHTS,
  INSIGHTS_ID,
  REEL_INSIGHTS,
  STORY_PREVIEW
} from '../models/routes';
import AddPurchaseStory from '../containers/PurchaseCompanyList/addPurchaseStory';
import ImportPurchaseStories from '../containers/PurchaseCompanyList/importPurchaseStories';
import CompanyPurchases from '../containers/PurchaseCompanyList/companyPurchases';
import PurchaseCompanyList from '../containers/PurchaseCompanyList/purchaseCompanyList';
import Login from '../containers/login/login';
import { auth as AuthObject } from '../services/login';
import StoryListing from '../containers/storyListing/storyListing';
// import InviteScreen from '../containers/InviteScreen/inviteScreen';
import AdminUserScreen from '../containers/AdminUserScreen/AdminUserScreen';
import EditStory from '../containers/editStory/editStory';
import AddCompany from '../containers/addCompany/addCompany';
import CompanyList from '../containers/CompanyList/displayCompanyList';
import Story from '../containers/storyListing/activeStoryListing';
import DisplayUserList from '../containers/User/UserListing';
import User from '../containers/User/User';
import AllCompanyStories from '../containers/storyListing/allCompanyStoriesListing';
import InviteUser from '../components/InviteUser/inviteUser';
// import EditCompany from '../components/editCompany/editCompany';
import EditCompany from '../containers/editCompany/editCompany';
// import Report from '../containers/report/report';
import Report from '../components/report/report';
import Insights from '../components/insights/insights';
import ReelsInsights from '../components/insights/reelInsights';
import StoryPreview from '../components/storyPreview/storyPreview';
import HealthCheck from '../components/healthCheck';

import history from './history';

// IMPORT ERROR BOUNDARY
import ErrorBoundary from '../components/ErrorBoundary/ErrorBoundary';

const PrivateRoute = () => {
  const location = useLocation();
  return ((AuthObject.isAuthenticated)
    ? <ErrorBoundary>
      <Outlet />
    </ErrorBoundary>
    : <Navigate to='/' state={{ from: location }} />
  )
}

export default (
  <BrowserRouter>
    <Routes>
      <Route path='/health-check' element={<HealthCheck />} />
      <Route path={LOGIN_ROUTE} element={<Login />} />
      <Route path={INVITE_USER} element={<InviteUser />} />
      <Route path={STORY_PREVIEW} element={<StoryPreview />} />
      <Route element={<PrivateRoute />}>
        <Route path={HOME_ROUTE} element={<PurchaseCompanyList />} />
        <Route path={COMPANY_PURCHASES_ROUTE} element={<CompanyPurchases />} />
        <Route path={PURCHASE_ADD_STORY_ROUTE} element={<AddPurchaseStory />} />
        <Route path={PURCHASE_IMPORT_STORIES_ROUTE} element={<ImportPurchaseStories />} />
        <Route path={PURCHASE_STORIES_ROUTE} element={<Story key="purchase-stories" />} />
        <Route path={EDIT_STORY_SCREEN_ROUTE} element={<EditStory />} exact />
        <Route path={ADD_COMPANY_ROUTE} element={<AddCompany />} exact />
        <Route path={STORY_ROUTE} element={<Story key="company-stories" />} exact />
        <Route path={STORY_LISTING_ROUTE} element={<StoryListing />} exact />
        <Route path={ALL_STORY_ROUTE} element={<AllCompanyStories />} exact />
        <Route path={ADMIN_USER_SCREEN_ROUTE} element={<AdminUserScreen />} exact />
        <Route path={COMPANY_ROUTE} element={<CompanyList />} exact />
        <Route path={USER_LISTING_ROUTE} element={<DisplayUserList />} exact />
        <Route path={USER_ROUTE} element={<User />} exact />
        <Route path={EDIT_COMPANY} element={<EditCompany />} exact />
        <Route path={REPORT} element={<Report />} exact />
        <Route path={INSIGHTS} element={<Insights />} exact />
        <Route path={INSIGHTS_ID} element={<Insights />} exact />
        <Route path={REEL_INSIGHTS} element={<ReelsInsights />} exact />
      </Route>
    </Routes>
  </BrowserRouter>
);
